import logo from './logo.svg';
import React, { useEffect } from 'react';
import './App.css';
import './Dashboardcontent.css';
import './components/Home.css';
import './Admin/OrderDetails.css';
import './components/Sidebar.css';
import Transaction from './Admin/Transaction';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { lazy, Suspense } from 'react';
import Spinners from './components/Spinners';
import Spark from './components/Spark';
import ReactGA from 'react-ga4';
const Plan = lazy(() => import("./Admin/Plan"));
const Dashboard = lazy(() => import("./Admin/Dashboard"));
const HomePage = lazy(() => import("./components/HomePage"));
const Login = lazy(()=> import("./components/Login"))

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    ReactGA.initialize('G-PCJGCXSTKS'); // Replace with your GA4 Measurement ID
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  return (
    <>
        <Suspense fallback={<Spinners />}>
      <Router basename="/metzi-seller/app">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Dashboard/*" element={<Dashboard />} />
          <Route path="/plans" element={<Plan />} />
          <Route path="/spark" element={<Spark />} />
        </Routes>
      </Router>
        </Suspense>
      <Toaster position="top-center" />
    </>
  );
}

export default App;
